import React, {PureComponent} from "react"
import styled from "styled-components"

import {StatementItem} from "@irati/types"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"

import {CurrencyType} from "@irati/payments/enums"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"
import ExpanderItem from "../../../ExpanderItem"
import PrimaryDetails from "../../../PrimaryDetails"
import SecondaryDetails from "../../../SecondaryDetails/SpendRefund"
import {StyledCard} from "../../styled"

const StyledSecondaryDetails = styled(SecondaryDetails)`
  margin-top: 10px;
`

interface Props extends InjectIntl {
  className?: string
  statementItem: StatementItem
}

class SpendRefund extends PureComponent<Props> {
  render() {
    const {statementItem, className, formatMessage} = this.props
    const {transfer} = statementItem
    const {amount, spend, currency} = transfer
    const {dealHeader, dealThumbnailImage, redemptionUuid, orderTotal} = spend || {}
    const primaryDetails = {
      image: dealThumbnailImage || perkboxLogo,
      title: dealHeader,
      subTitle: formatMessage({id: "wallet.statementItem.spendRefund.primaryDetails.subTitle"}),
      amount: currency === CurrencyType.RP ? getNormalisedValue(true, currency, amount) : amount,
      currency,
      status: StatusType.SPENT_REFUND
    }
    const secondaryDetails = {
      redemptionUuid,
      orderTotal
    }

    const idNamespace = id("spend-refund-statement-item", this.props)

    if (orderTotal) {
      return (
        <ExpanderItem
          className={className}
          id={idNamespace}
          PrimaryElement={() => <PrimaryDetails id={idNamespace} data={primaryDetails} />}
          SecondaryElement={<StyledSecondaryDetails id={idNamespace} data={secondaryDetails} />}
        />
      )
    }

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails id={idNamespace} data={primaryDetails} imgHeightAuto />
      </StyledCard>
    )
  }
}

export default injectIntl(SpendRefund)
